// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface TabsRegistry {}

export type TabId = TabsRegistry extends { tabs: infer TTabs } ? TTabs : string;

export const ActiveTabNamespaceSuffix = 'ActiveTab';
export const DefaultTabNameSpace = 'activeTab';
